// extracted by mini-css-extract-plugin
export var bubble = "styles-module--bubble--71b3c";
export var messageBody = "styles-module--message-body--731a6";
export var receiver = "styles-module--receiver--791fb";
export var sender = "styles-module--sender--94ee2";
export var slideFromLeft = "styles-module--slide-from-left--951d3";